import { AppShell } from "@mantine/core";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/core/useAuth";
import { Sidebar } from "./Components/Sidebar";
import Header from "./Components/Header";
import LocationTracker from "../../shared/components/LocationTracker";

export function MainLayout() {
  const { user, staffProfile, isLoading } = useAuth();
  const location = useLocation();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "1.2em",
        }}
      >
        Loading...
      </div>
    );
  }

  // Only redirect if definitely not authenticated
  if (!user || !staffProfile) {
    return <Navigate to="/auth" state={{ from: location }} replace={false} />;
  }

  return (
    <AppShell padding="md" navbar={{ width: 250, breakpoint: "sm" }} header={{ height: 60 }} layout="alt">
      {/* Track location changes */}
      <LocationTracker />

      <AppShell.Header>
        <Header />
      </AppShell.Header>

      <AppShell.Navbar>
        <Sidebar />
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}

export default MainLayout;
